/** Map progress event / idle typing to a short colleague-style status. */
export function getLaikaWorkingStatus(
  isTyping: boolean,
  progressMessage?: string | null,
): string | null {
  if (!isTyping) return null;
  const trimmed = (progressMessage || '').trim();
  if (trimmed) return trimmed;
  return null;
}

/** Exact FR strings emitted by agent_v3/progress_events.py + llm_invoke. */
const BACKEND_STATUS_I18N: Record<string, string> = {
  'Je te réponds…': 'chatWidget.replyingNow',
  'Je cherche ce client…': 'chatWidget.statusClient',
  'Je regarde tes clients les plus actifs…': 'chatWidget.statusTopClients',
  'Je consulte ton planning…': 'chatWidget.statusPlanning',
  'Je consulte tes indispos…': 'chatWidget.statusUnavail',
  'Je calcule tes stats…': 'chatWidget.statusStats',
  "Je prépare l'email…": 'chatWidget.statusEmail',
  'Je contacte le support…': 'chatWidget.statusSupport',
  'Je regarde les forfaits…': 'chatWidget.statusForfaits',
  'Je regarde la facturation…': 'chatWidget.statusBilling',
  'Je vérifie Stripe…': 'chatWidget.statusStripe',
  'Je regarde tes services…': 'chatWidget.statusServices',
  'Je vérifie Google Calendar…': 'chatWidget.statusCalendar',
  'Je regarde tes SMS…': 'chatWidget.statusSms',
  'Je prépare le devis…': 'chatWidget.statusQuote',
  'Je regarde les notes…': 'chatWidget.statusNotes',
  'Je travaille sur ta demande…': 'chatWidget.statusGeneric',
};

/** Backend SSE statuses are FR; map known cues to the UI locale. */
export function localizeLaikaBackendStatus(
  message: string | null | undefined,
  t: (key: string) => string,
): string {
  const trimmed = (message || '').trim();
  const key = BACKEND_STATUS_I18N[trimmed];
  if (key) return t(key);
  return trimmed;
}
